import { render, staticRenderFns } from "./jobTransferAdd.vue?vue&type=template&id=42651750&scoped=true&"
import script from "./jobTransferAdd.vue?vue&type=script&lang=js&"
export * from "./jobTransferAdd.vue?vue&type=script&lang=js&"
import style0 from "./jobTransferAdd.vue?vue&type=style&index=0&id=42651750&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42651750",
  null
  
)

export default component.exports